import { Component, Inject, HostListener, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-insufficient-quantity-dialog',
  templateUrl: './insufficient-quantity-dialog.component.html',
  styleUrls: ['./insufficient-quantity-dialog.component.css']
})
export class InsufficientQuantityDialogComponent implements OnDestroy {
  private routerSub: Subscription;

  // Make Math available in the template
  Math = Math;
  
  constructor(
    public dialogRef: MatDialogRef<InsufficientQuantityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { productName: string, available: number, newQuantity: number },
    private router: Router
  ) {
    // Initialize with available quantity if no value provided
    if (this.data.newQuantity === undefined) {
      this.data.newQuantity = this.data.available;
    }
    // Close dialog on route change (e.g., nav bar click)
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialogRef.close();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  onConfirm(): void {
    // Return the entered quantity without validation
    console.log('Confirming with quantity:', this.data.newQuantity);
    this.dialogRef.close(this.data.newQuantity);
  }

  onCancel(): void {
    console.log('Dialog cancelled');
    this.dialogRef.close(null);
  }
  
  validateInput(): void {
    // Ensure the quantity is not negative
    if (this.data.newQuantity < 0) {
      this.data.newQuantity = 0;
    }
    // Allow overstock - no maximum restriction
    // Users can enter quantities higher than available stock
    
    // Round to 2 decimal places for better display
    this.data.newQuantity = Math.round(this.data.newQuantity * 100) / 100;
  }
  
  decreaseQuantity(): void {
    // Choose appropriate decrement based on current value
    let decrement = 1;
    
    if (this.data.newQuantity <= 1) {
      decrement = 0.1;
    }
    
    if (this.data.newQuantity <= 0.1) {
      decrement = 0.01;
    }
    
    // Allow going to zero or negative values
    const newValue = this.data.newQuantity - decrement;
    this.data.newQuantity = Math.round(newValue * 100) / 100;
  }
  
  increaseQuantity(): void {
    // Choose appropriate increment based on current value
    let increment = 1;
    
    if (this.data.newQuantity < 1) {
      increment = 0.1;
    }
    
    if (this.data.newQuantity < 0.1) {
      increment = 0.01;
    }
    
    // Allow any value, no maximum restriction
    const newValue = this.data.newQuantity + increment;
    this.data.newQuantity = Math.round(newValue * 100) / 100;
  }

  // Close dialog only when clicking on the outermost container
  onDialogClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    // Only close if clicking on the outermost container
    if (target.classList.contains('premium-dialog')) {
      this.onCancel();
    }
  }
}
